<template>
  <div class="d-container container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="fixed-table-container">
          <div class="fixed-table-inner">
            <table class="table table-striped table-bordered table-sticky">
              <thead>
                <tr>
                  <th width="5%">
                    <div class="th-inner">
                    #
                    </div>
                  </th>
                  <th width="{{90/(data.data[0].answer.length)}}%"  v-for="ques in data.data[0].answer" >
                    <div class="th-inner">
                      {{ques.ques ? ques.ques : ques.question}}
                    </div>
                  </th>
                  <th width="5%" >
                    <div class="th-inner">
                      领队
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody v-el:tbody>
                 <tr v-for="item in data.data" track-by="$index">
                  <td width="5%">{{item.userName}}</td>
                  <td width="{{90/(data.data[0].answer.length)}}%" v-for="ans in item.answer">
                    {{ans.answer}} {{ans.why}}
                  </td>
                  <td  width="5%">{{item.leader.name}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../libs/config'
  import $ from 'jquery'

  export default {
    data () {
      return {
        data: {},
        form: {
          tripAlias: '',
          start: '',
          end: ''
        }
      }
    },
    methods: {
      fixedTable () {
        $('.fixed-table-inner').css('height', $(window).height() - 150 + 'px')
        $('.th-inner').each((index, elem) => {
          let $elem = $(elem)
          $elem.css('width', $elem.parent().width() + 'px')
        })
      },
      fetchList () {
        let params = Object.assign({ page: 1 }, this.$route.query)
        return this.$http.get(`${config.apiWe}/product/feedback`, params)
          .then(({data}) => {
            data.data.forEach((item) => {
              item.isShowAns = false
            })
            this.data = data
            this.$nextTick(() => {
              this.fixedTable()
            })
          })
      },
      go (query) {
        this.$router.go({ query: Object.assign({}, this.$route.query, query) })
      },
      showAns (item) {
        item.isShowAns = !item.isShowAns
      }
    },
    route: {
      data () {
        return this.fetchList()
      }
    }
  }
</script>

<style scoped>
  .fixed-table-container {
    position: relative;
    padding-top: 50px;
  }
  .fixed-table-container thead > tr > th {
    padding: 0 !important;
    height: 0 !important;
  }
  .fixed-table-inner {
    overflow: auto;
  }
  .th-inner {
    position: absolute;
    top: 0;
    padding: 0 4px;
  }
  .d-container {
    margin: 0 5%;
  }
  .table-nowrap td,
  .table-nowrap th {
    white-space: nowrap;
  }
</style>



/** WEBPACK FOOTER **
 ** TripMemberList.vue?0f2a5b19
 **/